var React = require('react');

function Section3TopRightInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(-6 -6)"},[React.createElement("polygon",{"fill":"#E9D8FD","points":"21.9 8.333 53.864 21.9 40.296 53.864 8.333 40.296","transform":"rotate(30 31.098 31.098)","key":0}),React.createElement("circle",{"cx":"124.666","cy":"180.985","r":"26","fill":"#F58C8C","key":1})]));
}

Section3TopRightInline.defaultProps = {"width":"145","height":"201","viewBox":"0 0 145 201"};

module.exports = Section3TopRightInline;

Section3TopRightInline.default = Section3TopRightInline;
